import '@polymer/polymer/polymer-legacy.js';
import '@polymer/app-layout/app-drawer/app-drawer.js';
import '@polymer/app-layout/app-header/app-header.js';
import '@polymer/app-layout/app-toolbar/app-toolbar.js';
import '@polymer/iron-flex-layout/iron-flex-layout.js';
import '@polymer/iron-icons/iron-icons.js';
import '@polymer/iron-icons/social-icons.js';
import '@polymer/iron-icons/communication-icons.js';
import '@polymer/paper-icon-button/paper-icon-button.js';
import '@polymer/paper-menu-button/paper-menu-button.js';
import '@cbar/localizemixin/LocalizeMixin.js';
import '@polymer/paper-listbox/paper-listbox.js';
import '@polymer/paper-item/paper-item.js';
import '@polymer/iron-image/iron-image.js';
import './cbar-header-shared-styles.js';
import {PolymerElement, html} from '@polymer/polymer/polymer-element.js';

/**
 * `cbar-header`
 *
 *
 * @customElement
 * @polymer
 * @demo demo/index.html
 */
class CbarHeader extends Cbar.LocalizeMixin(PolymerElement) {
  static get template() {
    return html`
        <style include="cbar-header-shared-styles">
            :host {
                display: block;

                position: fixed;
                top: 0;
                right: 0;
                left: 0;

                width: 100%;
                height: 64px;
            }

            app-toolbar {
                background-color: var(--cbar-header-background-color, #4285f4);
                color: var(--cbar-header-color, #fff);
                padding-top: env(safe-area-inset-top);
            }

            #appNameDiv {
                text-overflow: ellipsis;
                word-break: break-all;
                overflow: hidden;
                padding: 4px 0;
                color: var(--cbar-header-color, white);
            }

            #appName {
                color: var(--cbar-header-color, white);
            }

            paper-icon-button {
                --paper-icon-button-ink-color: white;

                /* Don't let the icons shrink on smaller devices */
                flex-shrink: 0;
            }

            paper-icon-button ~ [main-title] {
                margin-left: 24px;
            }

            app-header {
                @apply --layout-fixed-top;
                color: #fff;

                --app-header-background-rear-layer: {
                    background-color: #ef6c00;
                };
            }

            app-drawer {
                overflow: hidden;
                --app-drawer-scrim-background: rgba(0, 0, 33, 0.3);

            }

            app-drawer app-toolbar {
                /** Toolbar in the app-drawer should be white **/
                background-color: #fff;
                color: #000;

                @apply --cbar-header-app-drawer-toolbar;
            }

            .toolbar-title {
                white-space: nowrap;
                word-break: break-all;
                text-overflow: ellipsis;
                overflow: hidden;
                min-width: 0;
            }

            app-drawer[persistent] {
                margin-top: 64px;

                /**
                 * Set z-index to -1 so that the header overlaps the
                 * app-drawer when it is persistent
                 */
                z-index: -1;
            }

            div[main-title] {
                display: flex;
                align-items: center;
                white-space: nowrap;
                min-width: 0;
                @apply --cbar-header-title-and-slot-container;
            }

            /**
             * Can't use :host ::slotted because FireFox needs the
             * left side of the selector to be the immediate parent of the
             * slot
             * @see https://github.com/webcomponents/shadycss/issues/5#issuecomment-257032865
             */
            div[main-title] ::slotted([slot=dropdown]) {
                pointer-events: auto;
                margin: 0 15px;
                display: inline-flex;
            }

            #searchForm {
                position: absolute;
                left: 70px;
                right: 0;

                /* Use safe-ara-inset-top to make sure that mobile devices properly hide/show the search bar */
                top: env(safe-area-inset-top);
                transform: translateY(calc((-1 * env(safe-area-inset-top, 0)) - 70px));
                transition: transform 0.3s;

                height: 64px;
            }

            #searchForm.open {
                transform: translateY(0);
            }

            #search {
                height: 100%;
                width: 100%;
                color: var(--cbar-header-search-color, black);
                padding: 0 16px;
                border: 0;
                border-bottom: 1px solid #e1e2e3;
                outline: 0;
            }

            #searchForm paper-icon-button {
                --paper-icon-button-ink-color: black;
                color: black;

                position: absolute;
                top: 15px;
                right: 10px;
            }

            iron-image.person-image {
                height: 32px;

                --iron-image-width: 32px;
                --iron-image-height: 32px;

                border-radius: 50%;

                margin-right: 15px;
            }

            #drawer-contents::slotted(*) {
                overflow: scroll;
                height: 100%;
            }

            :host([has-footer]) #drawer-contents::slotted(*) {
                height: calc(100% - 110px);
            }

            #powered-by::slotted(*) {
                position: absolute;
                width: 100%;
                top: calc(100% - 170px);
                text-align: center;
                color: var(--cbar-header-color, white);
                background-color: var(--cbar-header-background-color, #4285f4);
            }

            @media (max-width: 600px) {
                /* Mobile */
                #appName {
                    display: none;
                }

                div[main-title] ::slotted([slot=dropdown]) {
                    margin-left: 0;
                }
            }
        </style>

        <app-header reveals="" fixed="" shadow="[[shadow]]">
            <app-toolbar>
        <span>
          <template is="dom-if" if="[[!noDrawer]]">
            <paper-icon-button icon="menu" on-tap="toggleDrawer"></paper-icon-button>
          </template>
        </span>

                <div main-title>
                    <a href="[[homeUrl]]" id="appNameDiv">
                        <span id="appName">[[appName]]</span>
                    </a>

                    <slot name="dropdown"></slot>
                </div>

                <slot name="menu-actions"></slot>
                <paper-icon-button icon="search" on-tap="showSearchForm" hidden\$="[[noSearch]]"></paper-icon-button>

                <paper-icon-button style="margin: 8px;" icon="communication:chat" on-tap="handleChatTapped" hidden\$="[[noChat]]"></paper-icon-button>

                <paper-menu-button hidden$="[[noNotifications]]" horizontal-align="right" vertical-align="top" vertical-offset="50" close-on-activate="" no-animations id="notifications-dropdown">
                    <paper-icon-button icon="social:notifications" slot="dropdown-trigger">
                    </paper-icon-button>
                    <paper-listbox slot="dropdown-content">
                        <slot name="notifications" id="notifications"></slot>
                    </paper-listbox>
                </paper-menu-button>

                <paper-menu-button id="appsContainer" hidden="" horizontal-align="right" vertical-align="top" vertical-offset="50" close-on-activate="">
                    <paper-icon-button icon="apps" slot="dropdown-trigger"></paper-icon-button>

                    <paper-listbox slot="dropdown-content">
                        <slot name="apps" id="apps" on-slotchange="_appsSlotChanged"></slot>
                    </paper-listbox>
                </paper-menu-button>

                <span>
          <template is="dom-if" if="[[!noUserMenu]]">
            <template is="dom-if" if="[[loggedIn]]">
              <paper-menu-button horizontal-align="right" vertical-offset="50" close-on-activate="">
                <paper-icon-button icon="more-vert" slot="dropdown-trigger"></paper-icon-button>
    
                <slot name="user-menu" slot="dropdown-content">
                    <paper-listbox>
                      <a href="[[profileUrl]]" tabindex="-1">
                        <paper-item>
                          <iron-image class="person-image" src="[[profileImageUrl]]"></iron-image>
                          <span>[[username]]</span>
                        </paper-item>
                      </a>
        
                      <a on-tap="_logout" href="[[logoutUrl]]">
                        <paper-item>[[localize('Log Out')]]</paper-item>
                      </a>
                    </paper-listbox>
                </slot>
              </paper-menu-button>
            </template>
            
            
            <template is="dom-if" if="[[!loggedIn]]">
             <paper-menu-button horizontal-align="right" vertical-offset="50" close-on-activate="">
                <paper-icon-button icon="account-circle" slot="dropdown-trigger" aria-label="Sign up/Log in"></paper-icon-button>
                <slot name="user-menu" slot="dropdown-content">
                 <paper-listbox>
                       <paper-item on-tap="__handleSignUp"><span>Sign Up</span></paper-item>
                       <paper-item on-tap="__handleSignIn"><span>Log In</span></paper-item>
                 </paper-listbox>
                </slot>
              </paper-menu-button>
            </template>
          </template>
        </span>

                <span>
          <template is="dom-if" if="[[!noSearch]]">
            <form id="searchForm" class\$="[[_searchFormClass]]" on-submit="searchFormSubmitted">
              <input id="search" type="text" placeholder="[[localize(searchPlaceholder)]]" on-blur="closeSearchForm">
  
              <paper-icon-button icon="close"></paper-icon-button>
            </form>
          </template>
        </span>
            </app-toolbar>
        </app-header>

        <template is="dom-if" if="[[!noDrawer]]">
            <app-drawer id="drawer" swipe-open="" persistent$="[[persistentDrawer]]" on-opened-changed="_appDrawerToggled">
                <template is="dom-if" if="[[!persistentDrawer]]">
                    <a href="[[homeUrl]]">
                        <app-toolbar>
                            <div class="toolbar-title">[[drawerTitle]]</div>
                        </app-toolbar>
                    </a>
                </template>

                <slot name="drawer-contents" id="drawer-contents"></slot>
                <slot name="powered-by" id="powered-by" on-slotchange="__footerChanged"></slot>
            </app-drawer>
        </template>
    `;
  }

  static get is() {
    return 'cbar-header';
  }

  static get properties() {
    return {
      /**
       * The name of the app to place in the header
       */
      appName: {
        type: String,
        value: 'App Name',
        observer: '_appNameChanged',
      },

      /**
       * The title to display in the app drawer.
       *
       * @default Defaults to appName
       */
      drawerTitle: String,

      /**
       * The Url the user will be redirected to when
       * the app name is clicked in the header
       */
      homeUrl: {
        type: String,
        value: 'javascript:void(null)',
      },

      /**
       * Whether this header should not include an app drawer
       */
      noDrawer: {
        type: Boolean,
        value: false,
      },

      /**
       * Whether this header should not include the search icon/form
       */
      noSearch: {
        type: Boolean,
        value: false,
      },

      /**
       * Whether this header should not include the more-vert user menu
       */
      noUserMenu: {
        type: Boolean,
        value: false,
      },

      /**
       * Whether the app-drawer should be persistent
       */
      persistentDrawer: {
        type: Boolean,
        value: false,
      },

      /**
       * Whether the component should remember the drawer's open/closed state
       */
      rememberDrawerState: {
        type: Boolean,
        value: false,
      },

      /**
       * The placeholder for the search textbox
       */
      searchPlaceholder: {
        type: String,
        value: 'Search',
      },

      /**
       * The logged in user's username
       */
      username: String,

      /**
       * The Url to redirect the user to when they tap
       * the profile option in the "more" dropdown menu
       */
      profileUrl: {
        type: String,
        value: 'javascript:void(null)',
      },

      /**
       * The logged in user's profile image
       */
      profileImageUrl: String,

      /**
       * The url to redirect to when the logout link is clicked
       */
      logoutUrl: {
        type: String,
        value: 'https://login.authentickated.com/user/logout',
      },

      _savedDrawerState: {
        type: Boolean,
        value: function () {
          return 'not set';
        },
      },
      /**
       * Boolean that controls whether the header has a dropdown or not.
       */
      shadow: {
        type: Boolean,
        value: false
      },
      loggedIn: {
        type: Boolean,
        value: false
      },
      noNotifications: {
        type: Boolean,
        value: false
      },
      hasFooter: {
        type: Boolean,
        value: false,
        reflectToAttribute: true
      },
      noChat: {
        type: Boolean,
        value: false
      }
    };
  }

  static get observers() {
    return [
      '_savedDrawerStateChanged(noDrawer, rememberDrawerState, _savedDrawerState)',
    ];
  }

  ready() {
    super.ready();

    if (this.$.apps.assignedNodes({flatten: true}).length > 0) {
      // On Safari, the slotchange event does not get fired
      // when we're upgrading an element (see https://www.polymer-project.org/2.0/docs/devguide/custom-elements#element-upgrades)
      // but does get called for elements that get directly created by the parser.
      // See https://github.com/whatwg/dom/issues/447 for details
      this.$.appsContainer.hidden = false;
    }
  }

  get notificationsDropdown() {
    if (!this._notificationsDropdown) {
      this._notificationsDropdown = this.root.querySelector('#notifications-dropdown');
    }
    return this._notificationsDropdown;
  }

  _savedDrawerStateChanged(noDrawer, rememberDrawerState, savedState) {
    let isMobile = this.__isMobileView();

    let shouldOpenForPersistence = savedState === 'not set' && this.persistentDrawer && !isMobile
    let shouldOpenForState = savedState && !isMobile;
    let shouldInitialOpen = shouldOpenForPersistence || shouldOpenForState;

    if (noDrawer || !shouldInitialOpen || !this._initialDrawerStateLoaded) {
      return;
    }

    requestAnimationFrame(() => {
      if (savedState) {
        this.drawer.open();
      } else {
        this.drawer.close();
      }

      // Flag that we've definitely loaded our initial drawer state
      // at this point.
      this._initialDrawerStateLoaded = true;
    });
  }

  _appNameChanged(appName) {
    if (!this.drawerTitle) {
      this.drawerTitle = appName;
    }
  }

  /**
   * Show/hide apps dropdown depending on if we have slotted content.
   *
   * @param {Event} e
   */
  _appsSlotChanged(e) {
    this.$.appsContainer.hidden = !e.target.assignedNodes({flatten: true}).length;
  }

  /**
   * Handler for when the app-drawer is toggled.
   */
  _appDrawerToggled(e) {
    const callback = () => {
      if (this.rememberDrawerState && this._initialDrawerStateLoaded) {
        // Save to localStorage
        // Need to wait for next event loop to ensure
        // that this initial call does not override
        // our localStorage value before we've even used it.
        localStorage.setItem('cbar-header-app-drawer-state', e.detail.value);
      }

      this.dispatchEvent(new CustomEvent('app-drawer-toggled', {
        detail: {
          drawer: this.drawer,
          opened: e.detail.value,
          bubbles: true,
          composed: true,
        }
      }));

      // At this point, flag that our initial drawer state has been loaded,
      // as the `_savedDrawerStateChanged` observer may have never been fired.
      this._initialDrawerStateLoaded = true;

      this.__checkOpenedStatus();
    };

    this.debounce(callback());
  }

  debounce(func, timeout = 300) {
    let timer;
    return (...args) => {
      clearTimeout(timer);
      timer = setTimeout(() => { func.apply(this, args); }, timeout);
    };
  }

  get drawer() {
    if (!this.$.drawer) {
      this.$.drawer = this.root.querySelector('app-drawer');
    }

    return this.$.drawer;
  }

  get searchForm() {
    if (!this.$.search) {
      this.$.search = this.root.querySelector('#search');
    }

    return this.$.search;
  }

  toggleDrawer() {
    this.drawer.toggle();
  }

  showSearchForm(e) {
    // It's important to prevent the default click handler
    // for iOS devices to not immediately fire the blur event
    // on our input causing the search form to close
    e.preventDefault();

    this._searchFormClass = 'open';

    // Focus the search form input
    this.searchForm.setSelectionRange(0, this.searchForm.value.length);
    this.searchForm.focus();
  }

  closeSearchForm() {
    this.searchForm.blur();
    this._searchFormClass = '';
  }

  searchFormSubmitted(e) {
    e.preventDefault();

    this.closeSearchForm();

    this.dispatchEvent(new CustomEvent('search-submitted', {
      detail: this.searchForm.value || '',
      bubbles: true,
      composed: true,
    }));
  }

  _logout(e) {
    // First fire a logout event.
    let logoutEvent = new CustomEvent('logout', {
      bubbles: true,
      composed: true,
      cancelable: true,
    });

    this.dispatchEvent(logoutEvent);

    if (logoutEvent.defaultPrevented) {
      // If any listeners prevented the default functionality,
      // ensure we don't redirect to our logoutUrl.
      e.preventDefault();
    }
  }

  __handleSignUp(e) {
    this.dispatchEvent(new CustomEvent('signup-clicked', {
      bubbles: true,
      composed: true
    }));
  }

  __handleSignIn(e) {
    this.dispatchEvent(new CustomEvent('signin-clicked', {
      bubbles: true,
      composed: true
    }));
  }

  handleChatTapped() {
    this.dispatchEvent(new CustomEvent('chat-tapped', {
      bubbles: true,
      composed: true
    }))
  }

  __footerChanged(e) {
    this.hasFooter = e.target.assignedNodes({flatten: true}).length > 0;
  }

  __checkOpenedStatus() {
    this._savedDrawerState = localStorage.getItem('cbar-header-app-drawer-state') === "true";
  }

  __isMobileView() {
    const toMatch = [
      /Android/i,
      /webOS/i,
      /iPhone/i,
      /iPad/i,
      /iPod/i,
      /BlackBerry/i,
      /Windows Phone/i
    ];

    return toMatch.some((toMatchItem) => {
      return navigator.userAgent.match(toMatchItem);
    });
  }
}

window.customElements.define(CbarHeader.is, CbarHeader);
